// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/design-tokens.css';
import './styles/typography.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
